import { Button, Modal, Form, Row, Col, Select, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleFetchUsers, handleImpersonateUser } from "../../api/users";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

const { Option } = Select;

export default function Impersonate({ isVisible, setVisible }: any) {
  const { impersonate } = useContext(AuthContext);
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleImpersonateUser,
    onSuccess: (data: any) => {
      const credentials = {
        auth: data.user,
      };
      impersonate(credentials);
      message.success("Assigned Successfully");
      form.resetFields();
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const { data: users } = useQuery({
    queryKey: ["allUsers"],
    queryFn: () => handleFetchUsers({}),
  });

  const onSubmit = async () => {
    const { user } = await form.getFieldsValue();
    await mutate({ _id: user });
    setVisible(false);
  };

  const userOptions = users?.records?.map((item: any) => (
    <Option value={item?._id}>{item?.name}</Option>
  ));
  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Impersonate"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="impersonateApprover"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Impersonate
        </Button>,
      ]}
    >
      <Form
        id="impersonateApprover"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="user"
              label="Approver"
              rules={[
                {
                  required: false,
                  message: "Please select approver",
                },
              ]}
            >
              <Select
                showSearch
                placeholder={`Select `}
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
